export const CHAT_IA_BASE = "/chat-ia";

export const chatIaApp = {
  id: "chat-ia",
  iconClass: "ri-chat-smile-3-line",
  color: "bg-purple-500",
  route: CHAT_IA_BASE,
};
